import { useCallback } from 'react'
import _ from 'lodash'
import { useFormDispatch, useFormSelector } from '../../../redux/formStoreHooks'
import L3OncologyReview from '../l3/L3OncologyReview'
import { selectAllPrimaryTumors, selectAllMetastaticSites, selectAllTreatmentStatuses } from '../../../redux/selectOncology'
import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { newOncologyReviewItem, OncologyReviewConcept, OncologyReviewItem } from '@fusion-advantage/formlib'
import { setFormModelOncologyReview } from '../../../redux/formModelSlice'
import { useConceptValidator } from './useConceptValidator'

const L4OncologyReview = () => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4OncologyReview',
		cid: OncologyReviewConcept.cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.Object],
	})
	const dispatch = useFormDispatch()
	const oncologyData = useFormSelector(state => state.formModel.oncologyReview)
	const primaryTumors = useFormSelector(selectAllPrimaryTumors)
	const metastaticSites = useFormSelector(selectAllMetastaticSites)
	const treatmentStatuses = useFormSelector(selectAllTreatmentStatuses)
	const handleChange = useCallback((models: OncologyReviewItem[]) => {
		// dont send empty models to redux
		const nonEmptyModels = models.filter(x => !_.isEqual(newOncologyReviewItem(), x))
		dispatch(setFormModelOncologyReview(nonEmptyModels))
	}, [dispatch])
	if(errorNode) {
		return errorNode
	}
	return (
		<L3OncologyReview
			models={oncologyData}
			valueLists={{
				tumors: primaryTumors,
				treatmentStatuses: treatmentStatuses,
				metastaticSites: metastaticSites,
				metastaticSiteStatuses: treatmentStatuses,
			}}
			onChange={handleChange}
		/>
	)
}

export default L4OncologyReview